import { render, staticRenderFns } from "./djkAgreement.vue?vue&type=template&id=3381af52&scoped=true"
import script from "./djkAgreement.vue?vue&type=script&lang=js"
export * from "./djkAgreement.vue?vue&type=script&lang=js"
import style0 from "./djkAgreement.vue?vue&type=style&index=0&id=3381af52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3381af52",
  null
  
)

export default component.exports